<!--
# Module: 基本信息查询
-->
<template>
  <div class="manage-page">
    <div class="page-view">
      <div class="item-row" v-for="w in navMenu" :key="w.id" @click="opendialog(w.id)">
        <div class="name">
          <span>{{w.title}}</span>
        </div>
        <p class="tips">{{w.dec}}</p>
      </div>
    </div>
    <!-- 弹框 -->
    <div class="dialogform">
      <el-dialog
        v-if="dialog"
        :title="dialogtitle"
        :visible.sync="dialog"
        top="0"
        :width="dialigwidth"
        :before-close="handlecancel"
      >
        <el-divider v-if="dialogname === 'informationQuery_basic'" />
        <!-- 基本信息 -->
        <el-form
          :model="formbasic"
          label-width="200px"
          ref="saveformbasic"
          v-if="dialogname === 'informationQuery_basic'"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="单位编码:" prop="code">
                <el-input v-model="formbasic.code" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="单位名称:" prop="name">
                <el-input v-model="formbasic.name" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系人:" prop="contact_man">
                <el-input v-model="formbasic.contact_man" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话:" prop="contact_phone">
                <el-input v-model="formbasic.contact_phone" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="地址:" prop="addr_id">
                <el-cascader
                  v-model="formbasic.addr_id"
                  :options="Administrativeareas"
                  :props="{label: 'name', value: 'addr_oid', children: 'child', emitPath: false}"
                  disabled
                  :show-all-levels="true"
                >
                  <template slot-scope="{ data }">
                    <i class="iconfont"></i>
                    <span class="node-text">{{ data.name }}</span>
                  </template>
                </el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮政编码:" prop="postal_code">
                <el-input v-model="formbasic.postal_code" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="详细地址:" prop="addr_detail">
            <el-input v-model="formbasic.addr_detail" disabled></el-input>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否为重点户:" prop="is_mainuser">
                <el-switch v-model="formbasic.is_mainuser" disabled></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用水性质:" prop="usewater_id">
                <el-select v-model="formbasic.usewater_id" placeholder="请选择" disabled>
                  <el-option
                    v-for="item in Naturewater"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用水单价:" prop="usewater_price">
                <el-input v-model="formbasic.usewater_price" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="绿地面积:" prop="green_area">
                <el-input v-model="formbasic.green_area" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 水表信息 -->
        <el-table
          ref="Watermeterlistref"
          :data="Watermeterlist"
          highlight-current-row
          :fit="false"
          stripe
          height="200"
          max-height="500"
          border
          size="mini"
          v-if="dialogname === 'informationQuery_water'"
        >
          <el-table-column
            align="center"
            :resizable="false"
            show-overflow-tooltip
            type="index"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="code"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="用户编号"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="name"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="用户名称"
            width="198"
          ></el-table-column>
          <el-table-column
            prop="meter_state"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="水表状态"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="meter_price"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="用水单价"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="meter_dn"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="水表口径"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="install_date"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="安装日期"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="odesc"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="备注"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="addr_detail"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="地址"
            width="300"
          ></el-table-column>
          <el-table-column
            prop="create_man"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="创建人"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="create_time"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="创建时间"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="edit_man"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="修改人"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="edit_time"
            align="center"
            :resizable="false"
            show-overflow-tooltip
            label="修改时间"
            width="120"
          ></el-table-column>
        </el-table>
        <el-divider v-if="dialogname === 'informationQuery_basic'" />
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  A_UIR_TreeQuery, // 查询用水性质数据列表
  A_AAL_TreeQuery, // 查询行政区域
  A_WML_QueryWaterInfoByUesrId // 水表信息
} from '@/assets/js/axiosPresets'
export default {
  name: "basicsQueryMessage",
  data () {
    return {
      dialogtitle: "", // 弹框标题
      dialogname: "", // 弹框名称（做区别）
      dialog: false, // 是否显示弹框
      dialigwidth: "1000px", // 弹框长度
      formbasic: {
        code: "", // 单位编码
        name: "", // 单位名称
        contact_man: "", // 联系人
        contact_phone: "", // 联系电话
        addr_id: "", // 地址
        addr_detail: "", // 详细地址
        postal_code: "", // 邮政编码
        is_mainuser: "", // 重点户(0/1)
        usewater_id: "", // 用水性质
        usewater_price: "", // 用水单价
        green_area: "" // 绿化面积
      }, // 基本信息表单数据集合
      Watermeterlist: [], // 水表数据集合
      Naturewater: [], // 用水性质选择器数据集合
      Administrativeareas: [], // 行政区域级联选择器数据集合
      userInfo: null // 用户信息
    }
  },
  created () {
    this.getNaturewater()
    this.getTreeData()
  },
  computed: {
    // 用户信息
    basicsUser () {
      return this.$store.state.userInfo
    },
    // 选项卡：菜单导航
    navMenu () {
      return [
        { id: 'informationQuery_basic', title: '查询基本信息', dec: '查询用户的基本信息' },
        { id: 'informationQuery_water', title: '查询水表信息', dec: '查询计划户名下的水表信息' }
      ]
    }
  },
  watch: {
    // 监听用户信息
    basicsUser (v) {
      this.userInfo = this.$initUserInfo()
    }
  },
  mounted () {
    this.$init()
  },
  methods: {
    // 初始化：页面加载当前用户信息
    $init () {
      if (!this.userInfo) {
        this.userInfo = this.$store.state.userInfo
      }
    },
    // 初始化：获取基本信息(页面刷新加载)
    $initUserInfo () {
      if (this.$store.state.userInfo) {
        return this.$store.state.userInfo
      }
    },
    // 数据：请求用水性质接口
    async getNaturewater () {
      const wid = await A_UIR_TreeQuery({ price_pid: 0, scale: 3 })
      wid.data.Content.forEach(e => {
        this.$recursiveData(e)
      })
    },
    // 递归：处理用水性质数据，得到用水性质数据集合
    $recursiveData (R) {
      R.child.forEach(item => {
        if (item.child && item.child.length !== 0) {
          this.$recursiveData(item)
        } else {
          const _list = { value: item.price_oid, label: item.name }
          this.Naturewater.push(_list)
        }
      })
    },
    // 数据：请求行政区域接口
    async getTreeData () {
      const res = await A_AAL_TreeQuery({
        pid: 1,
        scale: 2
      })
      this.Administrativeareas = [
        { addr_oid: 0, child: this.beautyTreeData(res.data.Content, 1), level: 0, name: '佛山市', oid: 0 }
      ]
    },
    // 递归：处理行政区域数据，得到行政区域数据集合
    beautyTreeData (data, level) {
      data.forEach(item => {
        if (level < 2) {
          item.child = item.child || []
          this.beautyTreeData(item.child || [], level + 1)
        } else if (level === 2) {
          item.child = null
        }
      })
      return data
    },
    // 数据：请求当前用户水表信息
    async getQueryWatermeter () {
      const wid = await A_WML_QueryWaterInfoByUesrId(this.userInfo.oid)
      this.Watermeterlist = wid.data.Content
    },
    // 数据：档案信息赋值
    getUserassignment () {
      this.formbasic = {
        code: this.userInfo.code, // 单位编码
        name: this.userInfo.name, // 单位名称
        contact_man: this.userInfo.contact_man, // 联系人
        contact_phone: this.userInfo.contact_phone, // 联系电话
        addr_id: this.userInfo.addr_id, // 地址
        addr_detail: this.userInfo.addr_detail, // 详细地址
        postal_code: this.userInfo.postal_code, // 邮政编码
        is_mainuser: this.userInfo.is_mainuser, // 重点户(0/1)
        usewater_id: this.userInfo.usewater_id, // 用水性质
        usewater_price: this.userInfo.usewater_price, // 用水单价
        green_area: this.userInfo.green_area // 绿化面积
      }
    },
    // 功能: 打开弹框,赋值
    opendialog (e) {
      this.getQueryWatermeter()
      switch (e) {
        case 'informationQuery_basic':
          this.dialogname = 'informationQuery_basic'
          this.dialogtitle = '档案信息'
          this.getUserassignment()
          break
        case 'informationQuery_water':
          this.dialogname = 'informationQuery_water'
          this.dialogtitle = '水表信息'
          break
      }
      this.dialog = true
    },
    // 功能 : 重置数据（取消）
    handlecancel () {
      this.dialog = false
    }
  }
}
</script>